import PropTypes from "prop-types";
import { createContext, useContext, useState } from "react";

const WebsiteNameContext = createContext();

export const WebsiteNameProvider = (props) => {
  const [websiteName, setWebsiteName] = useState(document?.title);

  return (
    <WebsiteNameContext.Provider value={{ websiteName, setWebsiteName }}>
      {props.children}
    </WebsiteNameContext.Provider>
  );
};

WebsiteNameProvider.propTypes = {
  children: PropTypes.node
};

export const useWebsiteName = () => useContext(WebsiteNameContext);
